"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Col = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const getColumnClass = (cols) => {
    if (cols <= 1) {
        return 'md:col-span-1';
    }
    if (cols >= 12) {
        return 'md:col-span-12';
    }
    return `md:col-span-${Math.round(cols)}`;
};
const Col = ({ children, className, span }) => {
    return react_1.default.createElement("div", { className: (0, classnames_1.default)(getColumnClass(span), 'col-span-12', className) }, children);
};
exports.Col = Col;
